import request from '@/utils/request'

export function listAssistanceMoneyDetails(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assistanceMoney.listAssistanceMoneyDetails',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}